import React from 'react';
import './RecipeDetail.css';
import Footer from './Footer';

const RecipeDetail = ({ recipe, onBack }) => {
  if (!recipe) return null;

  const details = recipe.details || {};
  const summary = details.summary || recipe.description || '';
  const ingredients = details.ingredients || recipe.ingredients || [];
  const instructions = details.instructions || recipe.instructions || [];
  const tips = details.tips || [];
  const calories = details.calories || '';

  return (
    <div className="recipe-detail-container">
      <div className="recipe-detail-image-wrapper">
        <img src={recipe.image} alt={recipe.title} className="recipe-detail-image" />
      </div>
      <div className="recipe-detail-content">
        <div className="recipe-detail-header">
          <h2>{recipe.title}</h2>
          <div className="recipe-detail-time">
            <span role="img" aria-label="clock">⏲️</span> {recipe.time}
          </div>
        </div>
        {summary && <div className="recipe-detail-desc">{summary}</div>}
        <div className="recipe-detail-section">
          <h3>Malzemeler:</h3>
          <ul>
            {ingredients.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
        </div>
        <div className="recipe-detail-section">
          <h3>Yapılışı:</h3>
          <ol>
            {instructions.map((step, i) => <li key={i}>{step}</li>)}
          </ol>
        </div>
        {tips.length > 0 && (
          <div className="recipe-detail-section">
            <h3>Püf Noktası:</h3>
            <ul>
              {tips.map((tip, i) => <li key={i}>{tip}</li>)}
            </ul>
          </div>
        )}
        {calories && (
          <div className="recipe-detail-section">
            <h3>Kalori Bilgisi:</h3>
            <div>{calories}</div>
          </div>
        )}
      </div>
      <Footer />
      <button className="detail-back-btn" onClick={onBack}>Geri</button>
    </div>
  );
};

export default RecipeDetail; 